<script setup lang="ts">
import getYouTubeID from "get-youtube-id";

const store = useYoutubeStore();

const props = defineProps<{ src: string }>();
const wrapper = ref<HTMLElement>();
const { width, height } = useElementSize(wrapper);
const cssWidth = computed(() => width.value.toString() + "px");
const cssHeight = computed(() => height.value.toString() + "px");

const playerVars = computed(() => ({
  autoplay: 1,
  controls: 0,
  modestbranding: 1,
  playsinline: 1,
  iv_load_policy: 3,
}));

const player = ref<HTMLElement>();

const divId: string = uniqueId("youtube-player-");

const videoId = computed(() => {
  return getYouTubeID(props.src) || props.src;
});

let youtubePlayer: YT.Player | null = null;

onMounted(async () => {
  await store.init();
  youtubePlayer = new YT.Player(player.value as HTMLElement, {
    height: "100%",
    width: "100%",
    videoId: videoId.value,
    playerVars: playerVars.value,
    events: {
      onReady: store.ytEventOnReady,
      onError: store.ytEventOnError,
      onStateChange: store.ytEventOnStateChange,
    },
  });
  store.onInit(youtubePlayer);
});

onBeforeUnmount(() => {
  store.onDestroy();
});
</script>

<template>
  <div
    ref="wrapper"
    class="youtube-player"
  >
    <div
      :id="divId"
      ref="player"
    ></div>
  </div>
</template>

<style scoped lang="postcss">
.youtube-player {
  @apply h-full w-full;
}

.youtube-player iframe {
  height: v-bind(cssHeight) !important;
  width: v-bind(cssWidth) !important;
  background: transparent !important;
}
</style>
